const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { validateAuthAndRedirect } from '@apps/main/lib/route-guards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  beforeLoad: ({
    location
  }) => validateAuthAndRedirect(location)
});